import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { Dropdown } from 'react-bootstrap';

import { metronic, toAbsoluteUrl } from '../../../_metronic';
import HeaderDropdownToggle from '../../partials/content/CustomDropdowns/HeaderDropdownToggle';

const languages = [
  {
    lang: 'pt',
    name: 'Português',
    flag: toAbsoluteUrl('/media/flags/255-brazil.svg')
  },
  {
    lang: 'en',
    name: 'English',
    flag: toAbsoluteUrl('/media/flags/226-united-states.svg')
  },
  {
    lang: 'es',
    name: 'Español',
    flag: toAbsoluteUrl('/media/flags/es.svg')
  }
];

const LanguageSelector = ({ iconType }) => {
  const [currentLanguage, setCurrentLanguage] = useState(languages[0]);

  const { search } = useLocation();
  const langRegex = /^\?lang=([a-z]{2})/;

  useEffect(() => {
    if (langRegex.test(search)) {
      const languageParam = langRegex.exec(search)[1];
      setCurrentLanguage(languages.find(x => x.lang === languageParam));
    }
  }, []);

  return (
    <Dropdown
      className="kt-header__topbar-item kt-header__topbar-item--langs"
      drop="down"
      alignRight
    >
      <Dropdown.Toggle as={HeaderDropdownToggle} id="dropdown-toggle-my-cart">
        <span
          className={clsx('kt-header__topbar-icon', {
            'kt-header__topbar-icon--brand': iconType === 'brand'
          })}
        >
          <img src={currentLanguage.flag} alt={currentLanguage.name} />
        </span>
      </Dropdown.Toggle>
      <Dropdown.Menu className="dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround">
        <ul className="kt-nav kt-margin-t-10 kt-margin-b-10">
          {languages.map(language => (
            <li
              key={language.lang}
              className={clsx('kt-nav__item', {
                'kt-nav__item--active': language.lang === currentLanguage.lang
              })}
            >
              <span
                className={clsx('kt-nav__link', {
                  'kt-nav__link--active': language.lang === currentLanguage.lang
                })}
              >
                <a href={`/privacy-policy?lang=${language.lang}`}>
                  <span className="kt-nav__link-icon">
                    <img src={language.flag} alt={language.name} />
                  </span>
                  <span className="kt-nav__link-text ml-2">
                    {language.name}
                  </span>
                </a>
              </span>
            </li>
          ))}
        </ul>
      </Dropdown.Menu>
    </Dropdown>
  );
};

const mapStateToProps = ({ i18n }) => ({ lang: i18n.lang });

export default connect(
  mapStateToProps,
  metronic.i18n.actions
)(LanguageSelector);

export const LanguageSelect = LanguageSelector;
